import { createElement } from '@core/helpers';
import Tooltip from 'src/app/project/features/tooltip/Tooltip';
import { EIntegrationStatus } from 'src/app/project/modules/custom-fields/custom-fields.model';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { checkFieldVolyTooltip } from '../../../../site-options/utils/check-field-voly-tooltip';
import { TColumn } from '../../../columns/column.model';

export function createIntegrationImage(column: TColumn): HTMLElement | string {
  if (!column.customFieldIds?.length) {
    return '';
  }

  const element = getImageElement(column.customFieldIds[0]);

  if (!element) {
    return '';
  }

  addTooltip(column, element);

  return element;
}

function addTooltip(column: TColumn, element: HTMLElement): void {
  const tooltipText = checkFieldVolyTooltip(column);

  const tooltip = new Tooltip({
    options: {},
    title: tooltipText,
    mobileTooltip: false,
    trimTooltip: false,
    childTooltip: false,
    element: element,
  });

  tooltip.createTooltip();
}

function getImageElement(customFieldId: string): HTMLElement {
  const customFields = GET_CUSTOM_FIELDS();
  const volyIntegrationActive = customFields[customFieldId]?.volyIntegrationActive;

  switch (volyIntegrationActive) {
    case EIntegrationStatus.ON:
      return createElement('img', {
        attrs: {
          src: EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_BIG,
        },
      });
    case EIntegrationStatus.DISABLED:
      return createElement('img', {
        attrs: {
          src: EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_BIG,
        },
      });
    default:
      return null;
  }
}
